import React from "react";
import { Card } from "../lib/ui";
import { useT } from "../lib/i18n";

function tone(pct) {
  if (pct >= 100) return { dot: "bg-emerald-500", bar: "bg-emerald-500", text: "text-emerald-600" };
  if (pct > 0) return { dot: "bg-amber-400", bar: "bg-amber-400", text: "text-amber-600" };
  return { dot: "bg-stone-300", bar: "bg-stone-300", text: "text-ink-mute" };
}

export default function OpsProgress({ title, items = [], testid }) {
  const { t } = useT();
  return (
    <Card className="p-4" data-testid={testid}>
      <p className="mb-3 text-xs font-bold uppercase tracking-wide text-ink-mute">{title || t("Today's Progress")}</p>
      <div className="grid grid-cols-2 gap-x-5 gap-y-3 sm:grid-cols-3 lg:grid-cols-5">
        {items.map((it) => {
          const c = tone(it.pct);
          return (
            <div key={it.key} data-testid={`${testid}-${it.key}`}>
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs font-semibold text-ink-soft">
                  <span className={`h-2 w-2 rounded-full ${c.dot}`} /> {t(it.label)}
                </span>
                <span className={`text-xs font-extrabold ${c.text}`}>{it.pct}%</span>
              </div>
              <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-stone-100">
                <div className={`h-full rounded-full ${c.bar} transition-all duration-500`} style={{ width: `${it.pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
